module.exports = __webpack_public_path__ + "img/companyiocn.40ae79cc.svg";